import { HStack } from '@chakra-ui/react'
import { useRouter } from '@tanstack/react-router'

import { useSearchState } from '@hooks/useSearchState'

import { formatDatePickerSelectionToParam, parseCalendarDayToLocalMidnight } from '@common/calendarDayInTimezone'
import { editorPaths } from '@common/config'

import { useTimezone } from '@contexts/TimezoneContext'

import { DateSelect } from './DateSelect'
import { MatchSelect } from './MatchSelect'

export function EventPicker() {
    const [{ date }, setSearchState] = useSearchState()
    const router = useRouter()
    const { timezone } = useTimezone()

    const parsedDate = parseCalendarDayToLocalMidnight(date, timezone)

    const handleDateChange = (newDate: Date) => {
        const { pathname } = router.state.location

        const matchingEditor = Object.keys(editorPaths).find(editor => pathname.includes(editor))

        if (matchingEditor) {
            router.navigate({ to: `${editorPaths[matchingEditor]}/todo` })
        }

        setSearchState({ date: formatDatePickerSelectionToParam(newDate), matchId: undefined })
    }

    return (
        <HStack justifyContent="space-between" gap={4} w="100%">
            <DateSelect date={parsedDate} setDate={handleDateChange} />
            <MatchSelect />
        </HStack>
    )
}
